<ul class="pv-menu-list">
  <li>
    <span>{{ 'settingsPanel.cameraMode' | transloco }}</span>
    <app-dropdown
      [value]="currentCameraMode"
      [options]="cameraModeOptions"
      (valueChange)="onCameraModeChange($event)"
      width="100%"
    ></app-dropdown>
  </li>

  <li>
    <span>{{ 'settingsPanel.fieldOfView' | transloco }}</span>
    :
    <span>{{ fieldOfView }}°</span>
    <app-slider
      [min]="20"
      [max]="120"
      [step]="1"
      [value]="fieldOfView"
      (valueChange)="onFOVChange($event)"
      width="100%"
    ></app-slider>
  </li>

  <div class="divider">
    <span>{{ 'settingsPanel.eyeDomeLighting' | transloco }}</span>
  </div>

  <li>
    <label>
      <app-checkbox
        [checked]="edlEnabled"
        (checkedChange)="onEDLEnabledChange($event)"
        [inline]="true"
      ></app-checkbox>
      <span>{{ 'settingsPanel.enableEdl' | transloco }}</span>
    </label>
  </li>
  <li [style.opacity]="edlEnabled ? 1 : 0.5" [style.pointer-events]="edlEnabled ? 'auto' : 'none'">
    <span>{{ 'settingsPanel.edlRadius' | transloco }}</span>
    :
    <span>{{ edlRadius.toFixed(1) }}</span>
    <app-slider
      [min]="1"
      [max]="4"
      [step]="0.1"
      [value]="edlRadius"
      (valueChange)="onEDLRadiusChange($event)"
      width="100%"
    ></app-slider>
  </li>
  <li [style.opacity]="edlEnabled ? 1 : 0.5" [style.pointer-events]="edlEnabled ? 'auto' : 'none'">
    <span>{{ 'settingsPanel.edlStrength' | transloco }}</span>
    :
    <span>{{ edlStrength.toFixed(1) }}</span>
    <app-slider
      [min]="0"
      [max]="5"
      [step]="0.1"
      [value]="edlStrength"
      (valueChange)="onEDLStrengthChange($event)"
      width="100%"
    ></app-slider>
  </li>
  <li [style.opacity]="edlEnabled ? 1 : 0.5" [style.pointer-events]="edlEnabled ? 'auto' : 'none'">
    <span>{{ 'settingsPanel.edlOpacity' | transloco }}</span>
    :
    <span>{{ edlOpacity.toFixed(1) }}</span>
    <app-slider
      [min]="0"
      [max]="1"
      [step]="0.1"
      [value]="edlOpacity"
      (valueChange)="onEDLOpacityChange($event)"
      width="100%"
    ></app-slider>
  </li>

  <div class="divider">
    <span>{{ 'settingsPanel.quality' | transloco }}</span>
  </div>

  <li>
    <app-dropdown
      [value]="currentQuality"
      [options]="qualityOptions"
      (valueChange)="onQualityChange($event)"
      width="100%"
    ></app-dropdown>
  </li>

  <li>
    <span>{{ 'settingsPanel.pointBudget' | transloco }}</span>
    :
    <span>{{ formatNumber(pointBudget) }}</span>
    <app-slider
      [min]="100000"
      [max]="10000000"
      [step]="100000"
      [value]="pointBudget"
      (valueChange)="onPointBudgetChange($event)"
      width="100%"
    ></app-slider>
  </li>

  <li>
    <span>{{ 'settingsPanel.minNodeSize' | transloco }}</span>
    :
    <span>{{ minNodeSize }}</span>
    <app-slider
      [min]="0"
      [max]="1000"
      [step]="10"
      [value]="minNodeSize"
      (valueChange)="onMinNodeSizeChange($event)"
      width="100%"
    ></app-slider>
  </li>

  <div class="divider">
    <span>{{ 'settingsPanel.points' | transloco }}</span>
  </div>

  <li>
    <span>{{ 'settingsPanel.pointSize' | transloco }}</span>
    :
    <span>{{ pointSize().toFixed(1) }}</span>
    <app-slider
      [min]="0.1"
      [max]="2.0"
      [step]="0.1"
      [value]="pointSize()"
      (valueChange)="onPointSizeChange($event)"
      width="100%"
    ></app-slider>
  </li>
  <li>
    <span>{{ 'settingsPanel.pointShape' | transloco }}</span>
    <app-dropdown
      [value]="currentPointShape"
      [options]="pointShapeOptions"
      (valueChange)="onPointShapeChange($event)"
      width="100%"
    ></app-dropdown>
  </li>
  <li>
    <span>{{ 'settingsPanel.pointSizing' | transloco }}</span>
    <app-dropdown
      [value]="currentPointSizeType"
      [options]="pointSizeTypeOptions"
      (valueChange)="onPointSizeTypeChange($event)"
      width="100%"
    ></app-dropdown>
  </li>
</ul>
